import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import VeiculosListar from '../../components/veiculos';


function VeiculosScreen () {
    return (
        <Fragment>
            <Head titulo="Veículos que fazem parte da Frota Municipal"/>
            <Header />
            <Container>
                <VeiculosListar />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default VeiculosScreen;